/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLetterH = createReactComponent("outline", "letter-h", "IconLetterH", [["path", { "d": "M17 4l0 16", "key": "svg-0" }], ["path", { "d": "M7 12l10 0", "key": "svg-1" }], ["path", { "d": "M7 4l0 16", "key": "svg-2" }]]);

export { IconLetterH as default };
//# sourceMappingURL=IconLetterH.mjs.map
